import type { PropsWithChildren } from 'react';
import { useLocalStorage } from 'react-use';
import { SplitPanel } from './SplitPanel';
import type { DragPos as SplitPanelDragPos } from './SplitPanel';

const DEFAULT_POSITION: SplitPanelDragPos = {
  x: [380],
  y: [],
};

type SplitProps = {
  localStoreKey?: string;
  defaultPosition?: SplitPanelDragPos;
  className?: string;
};

export function Split({
  children,
  localStoreKey,
  defaultPosition = DEFAULT_POSITION,
  className = '',
}: PropsWithChildren<SplitProps>) {
  const [savedDragPos, saveDragPos] = useLocalStorage<SplitPanelDragPos>(localStoreKey || 'no-key');

  const props = localStoreKey
    ? {
        dragPos: savedDragPos ?? defaultPosition,
        onDragEnd: saveDragPos,
        className,
      }
    : {
        dragPos: defaultPosition,
        className,
      };

  return <SplitPanel {...props}>{children}</SplitPanel>;
}
